import { useEffect } from 'react';
import { Filter, useToast } from 'vindi-ds-components';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '@services/api';

function useFilter({ status }) {
  const showToast = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  function listCustomers(params) {
    const { status: statusParams, page, perPage } = params;
    return api
      .get('/admin/customers', { status: statusParams, page, per_page: perPage })
      .then((response) => ({
        customers: response.data.customers,
        totalCount: response.data.total_customers,
      }))
      .catch(() => {
        showToast('Error no servidor', { severity: 'error' });
      });
  }

  useEffect(() => {
    navigate(location.pathname, { replace: true });
  }, []);

  const listing = Filter.useBrowserListing({
    queryOptions: {
      queryKey: `list-customers-${status}`,
      queryFn: listCustomers,
    },
    filterOptions: {
      defaultValues: {
        status,
      },
      schemaQuick: {
        status: 'string',
      },
      pagination: {
        enabled: true,
        getCount: async (query) => query?.data?.totalCount,
        perPage: 25,
      },
    },
  });

  return {
    listing,
  };
}

export default useFilter;
